import { useEffect, FC } from 'react';
import { ControlledDialog } from '@zoopla-eng/zds-components/dialog';
import { trackRelationshipFormShown } from '../tracking';
import {
    SpecifyRelationshipForm,
    SpecifyRelationshipModalProps,
    SPECIFY_RELATIONSHIP_MODAL_TEXT
} from './specify-relationship-form';

export const SpecifyRelationshipModal: FC<
    React.PropsWithChildren<
        SpecifyRelationshipModalProps & { isShowing: boolean }
    >
> = ({
    isShowing,
    existingRelationship,
    isSubmissionLoading,
    submissionError,
    action,
    onSaved
}) => {
    const onClose = () => {
        action?.dismissRelationshipModal?.();
    };

    useEffect(() => {
        if (isShowing) {
            trackRelationshipFormShown(action);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isShowing]);

    return (
        <ControlledDialog
            label="Property Relationship"
            isOpen={isShowing}
            title={SPECIFY_RELATIONSHIP_MODAL_TEXT.heading}
            onClose={onClose}
        >
            <SpecifyRelationshipForm
                existingRelationship={existingRelationship}
                isSubmissionLoading={isSubmissionLoading}
                submissionError={submissionError}
                action={action}
                onSaved={onSaved}
            />
        </ControlledDialog>
    );
};

export default SpecifyRelationshipModal;
